import { RATE_RESET } from 'src/app/product-capture/model/consts/rate-reset.const';
import { RATE_RESET_ENUM } from 'src/app/product-capture/model/enums/rate-reset.enum';
import { FCSelector } from '../../model/form-config.interface';
import { CouponPaths } from './product-capture-field-selectors-builder.consts';

const RATE_FIELDS = [
  CouponPaths.RATE_CALCULATION_METHOD,
  CouponPaths.RATE_RESET_SUSPENSION_LENGTH,
  CouponPaths.RATE_RESET_LOOKBACK_SHIFT,
  CouponPaths.RATE_OBSERVATION_PERIOD_SHIFT,
  CouponPaths.RATE_OBS_PERIOD_SHIFT_EXTRA_CALENDARS,
];

export const COMMON_DISABLED_EFFECTS = [
  {
    formControlNames: RATE_FIELDS,
    hidden: true,
    selectValues: [null],
  },
];

export const RATE_RESET_SELECTOR: FCSelector = {
  formControlNames: [CouponPaths.RATE_RESET],
  options: [
    {
      id: RATE_RESET_ENUM.DAILY,
      label: RATE_RESET[RATE_RESET_ENUM.DAILY],
      effects: [
        {
          formControlNames: RATE_FIELDS,
          hidden: false,
        },
        {
          formControlNames: [CouponPaths.RATE_CALCULATION_METHOD],
          selectValues: ['COMPOUNDING'],
        },
        {
          formControlNames: [CouponPaths.RATE_RESET_SUSPENSION_LENGTH],
          selectValues: [1],
        },
        {
          formControlNames: [CouponPaths.RATE_RESET_LOOKBACK_SHIFT],
          selectValues: ['1B'],
        },
        {
          formControlNames: [CouponPaths.RATE_OBSERVATION_PERIOD_SHIFT],
          selectValues: ['0B'],
        },
        {
          formControlNames: [CouponPaths.RATE_OBS_PERIOD_SHIFT_EXTRA_CALENDARS],
          selectValues: [null],
        },
      ],
    },
    {
      id: RATE_RESET_ENUM.IN_ADVANCE,
      label: RATE_RESET[RATE_RESET_ENUM.IN_ADVANCE],
      effects: COMMON_DISABLED_EFFECTS,
    },
    {
      id: RATE_RESET_ENUM.IN_ARREARS,
      label: RATE_RESET[RATE_RESET_ENUM.IN_ARREARS],
      effects: COMMON_DISABLED_EFFECTS,
    },
    {
      id: '',
      effects: COMMON_DISABLED_EFFECTS,
    },
  ],
};
